import getConfig from 'next/config';

import { getEntityUrl } from '@culture/common-helpers/cultureUtils';

const {
	publicRuntimeConfig: { basePath, baseUrl }
} = getConfig();

export const getCanonicalUrl = ({ entity, entityType, currentPath }) => {
	let canonicalPath = '';

	if (entity && entityType) {
		canonicalPath = getEntityUrl(entityType, entity);
	} else {
		canonicalPath = currentPath;
	}

	const canonicalUrl = new URL(`${baseUrl}${basePath}${canonicalPath}`);
	canonicalUrl.pathname = canonicalUrl.pathname.replace(/\/$/, '');
	canonicalUrl.search = '';

	return canonicalUrl.toString();
};
